<template>
    <div>
        <div class="grid grid-cols-7 gap-3">
            <Alert class="col-span-7 bg-next-orange">Importando un sottoprogetto crerai una nuova versione dell'attuale con i dati
                della scelta effettuata
            </Alert>

            <Alert class="col-span-7 bg-green-700" v-show="$attrs.waiting">Attendi mentre recuperiamo le informazioni</Alert>

            <div class="col-span-7">
                <VueMultiselect
                    :close-on-select="true"
                    :clear-on-select="true"
                    class="next-vue-multiselect-single"
                    placeholder="Sottoprogetto"
                    deselectLabel="Deseleziona"
                    selectedLabel="Selezionato"
                    selectLabel="Seleziona"
                    label="cod_nodo"
                    :options="sottoprogettoAutocomplete.options"
                    @search-change="sottoprogettoAutocomplete.search"
                    v-model="sottoprogettoAutocomplete.selection">
                    <template v-slot:option="{option}">
                            <span class="text-sm">
                                <span>Cod: {{ option.cod_nodo }}</span>
                                <span class="ml-2">BU: {{ option.bu_label }}</span>
                            </span>
                    </template>
                </VueMultiselect>
            </div>
            <Alert class="col-span-7 bg-next-pro" v-show="sottoprogettoAutocomplete.selection && !sottoprogettoVersioneAutocomplete.options.length">Non ci sono versioni manuali salvate del preventivo che si vuole importare,<br> salvare l'ultima versione e riprovare ad importare.</Alert>
            <div class="col-span-7">
                <VueMultiselect
                    :close-on-select="true"
                    :clear-on-select="true"
                    class="next-vue-multiselect-single"
                    placeholder="Versione"
                    deselectLabel="Deseleziona"
                    selectedLabel="Selezionato"
                    selectLabel="Seleziona"
                    label="version"
                    :options="sottoprogettoVersioneAutocomplete.options"
                    @search-change="sottoprogettoVersioneAutocomplete.search"
                    v-model="sottoprogettoVersioneAutocomplete.selection">
                </VueMultiselect>
            </div>
        </div>
        <div class="flex justify-end gap-3 pt-5">
            <NextButton variant="outline-secondary"
                        @click="$emit('chiudi')"
                        class="w-44 py-2 px-4">
                Chiudi
            </NextButton>
            <NextButton variant="primary" :disabled="$attrs.waiting"
                        @click="save"
                        class="w-44 py-2 px-4">
                Salva
            </NextButton>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Autocomplete from "@/setup/Autocomplete";
import tagsManager from "../api/Tags";
import sottoProgettiManager, {sottoProgettiVersioneManager} from "../api/SottoProgetti";
import Alert from "@/components/Alert.vue";
import {Watch} from "vue-property-decorator/lib/decorators/Watch";


@Options({
    name: 'ImportaSottoprogetto',
    components: {
        Alert,
        NextButton,
        MultiselectOption
    },
    props: {}
})
export default class ImportaSottoprogetto extends Vue {

    sottoprogettoAutocomplete: any = setup(() => Autocomplete(sottoProgettiManager, false))
    sottoprogettoVersioneAutocomplete: any = setup(() => Autocomplete(sottoProgettiVersioneManager, false,{sm:1}))//solo versioni manuali

    save() {
        if (this.sottoprogettoAutocomplete.selection && this.sottoprogettoVersioneAutocomplete.selection) {
            this.$emit('save', {
                sottoprogetto: this.sottoprogettoAutocomplete.selection,
                versione: this.sottoprogettoVersioneAutocomplete.selection
            })
        }
    }

    @Watch('sottoprogettoAutocomplete.selection')
    sottoprogetto() {
        this.sottoprogettoVersioneAutocomplete.callBinds = [this.sottoprogettoAutocomplete.selection?.id]
        this.sottoprogettoVersioneAutocomplete.emptyAll()
        this.sottoprogettoVersioneAutocomplete.search('', 0)
    }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
